<h1 ev-dialog-title data-testid="gps-error-title">{{ languageService.languageJSON.GPSErrorDialog_Title }}</h1>
<div ev-dialog-content data-testid="gps-error-container">
  @if (!fbAndroid && !fbIos) {
    <img alt="warning" class="gps-error-icon" [src]="'assets/icons/' + settingsService.getMap().Skin +  '/ui/start_icon.svg'" />
  }
  @if (!fbAndroid && !fbIos) {
    <ul>
      @for (informationTextElement of informationText; track informationTextElement) {
        <li [innerHtml]="informationTextElement">
        </li>
      }
    </ul>
  }

  <div class="fb-error">
    @if (fbAndroid) {
      <p [innerHtml]="languageService.languageJSON.GPSErrorDialog_Facebook_Info_Android">
      </p>
    }
    @if (fbAndroid) {
      <img [src]="'assets/icons/default/social/'+ languageService.getLanguage() +'/google_play_button.svg'" class="download-icon"
        data-testid="gps-error-google-play-btn"
        (click)="openUrl('https://play.google.com/store/apps/details?id=com.gpstuner.evnavigation')" />
    }
    @if (fbIos) {
      <p [innerHtml]="languageService.languageJSON.GPSErrorDialog_Facebook_Info_Ios">
      </p>
    }
  </div>
</div>
<div ev-dialog-actions>
  <button mat-button data-testid="gps-error-ok-btn" (click)="accept()">{{ languageService.languageJSON.Global_Ok }}</button>
</div>